app.directive('preferredUnit', function() {
    return {
        restrict: 'A',
        link: function($scope, $element, $attrs) {
            if ($attrs.preferredUnit && $attrs.preferredUnit.toLowerCase() === 'lb') {
                $element.text( Math.round($element.text() * 2.20462 * 100) / 100 );
            } else {
                $element.text( Math.round($element.text() * 100) / 100 );
            }
        }
    };
});
